<template>
  <v-navigation-drawer
    v-model="mini"
    app
    absolute
    temorary
    right
    class="drawer-color"
    color="#262D37"
  >
    <v-list nav dense>
      <v-list-item-group active-class="deep-purple--text text--accent-4">
        <v-list-item>
          <v-list-item-title> </v-list-item-title>
        </v-list-item>

        <v-list-item
          v-for="(menu, index) in menuList"
          :key="index"
          @click="menu.action($bus, $router, $store)"
          class="color-white"
        >
          <img :src="menu.img" class="home" />
          <v-list-item-title>
            <h3>{{ menu.menuName }}</h3>
          </v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <template v-slot:append>
      <div class="pa-2 d-flex justify-end" @click="logout()">
        <img
          src="/static/login/Logout.svg"
          :style="mini == true ? 'margin-right:15px;' : ''"
        />
        <v-btn text color="white" v-if="!mini">
          Logout
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import UserApi from "../api/UserService";
import Commonality from "../mixin/Commonality";
import { makeMenuList } from "./js/Drawer";
export default {
  mixins: [Commonality],
  created: function() {
    this.$bus.$on("mobileDrawer", () => {
      this.mini = !this.mini;
    });
  },
  data: function() {
    return {
      openDrawer: false,
      mini: true,
    };
  },
  computed: {
    menuList() {
      return makeMenuList(this.userState, this.constructionId);
    },
  },
  methods: {
    moveMenu(menu) {
      this.$router.push({ name: menu });
    },
    async logout() {
      let returnData = await UserApi.userLogout();
      if (returnData.data.success == "ok") {
        this.$bus.$emit("dialog", "로그아웃되셨습니다.");
        this.$store.commit("constructionIdChange", null);
        this.$store.commit("userStateChange", null);
        this.$store.commit("userListChange", null);
        this.$store.commit("resetStoreFilter");
        this.$router.push({ name: "Login" });
      }
    },
  },
};
</script>

<style scoped>
.height-48 {
  height: 48px;
}
.drawer-color {
  color: white;
  background: #262d37;
}

h3 {
  color: white;
}

.home {
  margin-right: 15px;
}
</style>
